import React from 'react';
import { FlatList, TouchableOpacity, View } from 'react-native';
import { ColorTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from '@voltmoney/schema';
import { convertTimeStampToFormattedDateAndTimeAMPMLowerCase, } from '../../stack/utils';
import Icon from '../../icon/Icon';
import Typography from '../../typography/Typography';
import { addCommasToNumber } from "../utils";
const WithdrawalFailedCard = ({ detailsAction, retryAction, triggerAction, withdrawalRejectedData, availableCreditLimit, }) => {
    const renderList = () => {
        return (withdrawalRejectedData?.length > 1 ? React.createElement(View, null,
            React.createElement(FlatList, { data: withdrawalRejectedData, renderItem: ({ item, index }) => individualItem(item, index), horizontal: true, style: { width: '100%' }, showsHorizontalScrollIndicator: false })) :
            React.createElement(View, { style: {
                    borderRadius: 8,
                    borderWidth: 1,
                    borderColor: "#FFEBEB",
                    height: 50,
                    backgroundColor: '#fff',
                    justifyContent: 'space-between',
                    alignContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'row',
                    paddingVertical: 8,
                    paddingHorizontal: 12
                } },
                React.createElement(View, { style: { flex: 1 } },
                    React.createElement(View, { style: { alignContent: 'center', alignItems: 'center', flexDirection: 'row' } },
                        React.createElement(Icon, { name: IconTokens.ErrorIcon, size: IconSizeTokens.XL, color: ColorTokens.RED_ALERT }),
                        React.createElement(View, { style: { marginLeft: 12 } },
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: withdrawalRejectedData[0]?.title, color: ColorTokens.Grey_Night }),
                            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3R, label: `₹${addCommasToNumber(withdrawalRejectedData[0]?.amount)} \u2022 ${convertTimeStampToFormattedDateAndTimeAMPMLowerCase(withdrawalRejectedData[0]?.dateEpoch)}`, color: ColorTokens.Grey_Charcoal })))),
                React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', alignContent: 'center', alignSelf: 'center', marginLeft: 16 } },
                    React.createElement(TouchableOpacity, { activeOpacity: 1, style: { zIndex: 99, paddingLeft: 16, paddingVertical: 8, paddingRight: 20 }, hitSlop: { top: 8, bottom: 8, left: 8, right: 8 }, onPress: () => {
                            triggerAction({
                                ...detailsAction,
                                payload: {
                                    type: withdrawalRejectedData[0]?.title?.includes("Repayment") ? "Repayment" : "Withdrawal",
                                    data: withdrawalRejectedData[0]?.data
                                }
                            });
                        } },
                        React.createElement(Typography, { label: "Details", typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Primary_100 })),
                    React.createElement(TouchableOpacity, { activeOpacity: 1, style: {
                            zIndex: 99,
                            paddingVertical: 7,
                            paddingHorizontal: 16,
                            borderRadius: 1000,
                            borderWidth: 1,
                            borderColor: '#1434CB',
                            alignItems: 'center',
                            alignContent: 'center',
                            justifyContent: 'center',
                        }, hitSlop: { top: 8, bottom: 8, left: 8, right: 8 }, onPress: () => {
                            triggerAction({
                                ...retryAction,
                                payload: {
                                    type: withdrawalRejectedData[0]?.type,
                                    amount: withdrawalRejectedData[0]?.amount,
                                    availableCreditLimit: availableCreditLimit,
                                    collectionType: withdrawalRejectedData[0].data?.collectionType,
                                    ...retryAction?.payload,
                                }
                            });
                        } },
                        React.createElement(Typography, { label: "Retry", typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Primary_100 })))));
    };
    const individualItem = (item, index) => {
        return (React.createElement(View, { style: {
                borderRadius: 8,
                borderWidth: 1,
                borderColor: "#FFCCCD",
                height: 50,
                backgroundColor: '#fff',
                justifyContent: 'space-between',
                alignContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                paddingVertical: 8,
                paddingHorizontal: 12,
                marginLeft: index > 0 ? 12 : 0
            } },
            React.createElement(View, { style: { flex: 1 } },
                React.createElement(View, { style: { alignContent: 'center', alignItems: 'center', flexDirection: 'row' } },
                    React.createElement(Icon, { name: IconTokens.ErrorIcon, size: IconSizeTokens.XL, color: ColorTokens.RED_ALERT }),
                    React.createElement(View, { style: { marginLeft: 12 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: item.title, color: ColorTokens.Grey_Night }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B3R, label: `₹${addCommasToNumber(item?.amount)} \u2022 ${convertTimeStampToFormattedDateAndTimeAMPMLowerCase(item?.dateEpoch)}`, color: ColorTokens.Grey_Charcoal })))),
            React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', alignContent: 'center', alignSelf: 'center', marginLeft: 12 } },
                React.createElement(TouchableOpacity, { activeOpacity: 1, style: { zIndex: 99, paddingLeft: 16, paddingVertical: 8, paddingRight: 20 }, hitSlop: { top: 8, bottom: 8, left: 8, right: 8 }, onPress: () => {
                        triggerAction({
                            ...detailsAction,
                            payload: {
                                type: item.title?.includes("Repayment") ? "Repayment" : "Withdrawal",
                                data: item?.data
                            }
                        });
                    } },
                    React.createElement(Typography, { label: "Details", typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Primary_100 })),
                React.createElement(TouchableOpacity, { activeOpacity: 1, style: {
                        zIndex: 99,
                        paddingVertical: 7,
                        paddingHorizontal: 16,
                        borderRadius: 1000,
                        borderWidth: 1,
                        borderColor: '#1434CB',
                        alignItems: 'center',
                        alignContent: 'center',
                        justifyContent: 'center',
                    }, hitSlop: { top: 8, bottom: 8, left: 8, right: 8 }, onPress: () => {
                        triggerAction({
                            ...retryAction,
                            payload: {
                                type: item?.type,
                                amount: item?.amount,
                                collectionType: item?.data?.collectionType,
                                availableCreditLimit: availableCreditLimit,
                                ...retryAction?.payload,
                            }
                        });
                    } },
                    React.createElement(Typography, { label: "Retry", typeDLS: TypographyTypeDLS.B2S, color: ColorTokens.Primary_100 })))));
    };
    return renderList();
};
export default WithdrawalFailedCard;
